'use strict';
var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// /data/websites/bestcompany1982.it/httpdocs/wp-content/themes/g2k-theme-2/node_modules/core-js/internals/path.js
// module id = 32
// module chunks = 0